import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-35494c81")

_pushScopeId("data-v-35494c81")
const _hoisted_1 = { class: "container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.gridElements, (gridElement, index) => {
      return (_openBlock(), _createBlock("button", {
        key: index,
        class: "item",
        style: { backgroundColor: gridElement.color }
      }, null, 4))
    }), 128))
  ]))
})